function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.091 14.864l-3.958-3.959a6.067 6.067 0 001.84-4.348A6.092 6.092 0 006.888.473 6.092 6.092 0 00.804 6.557a6.092 6.092 0 006.084 6.084 6.024 6.024 0 003.647-1.229l4.004 4.004a.374.374 0 00.546 0 .39.39 0 00.006-.552zM1.578 6.557a5.31 5.31 0 015.304-5.304 5.31 5.31 0 015.304 5.304 5.31 5.31 0 01-5.304 5.304 5.314 5.314 0 01-5.304-5.304z",
  fill: "#657087"
});

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "a776ae353bb38690f97fd78e8dfe4b1e.svg";
export { SvgSearch as ReactComponent };